module.exports = __webpack_public_path__ + "4893a92a058d1319df6814d8f6f5fc53.pdf";